export default "__VITE_ASSET__7f54bf74__"